import Model from 'flarum/common/Model';
export default class PollVote extends Model {
  poll() {
    return Model.hasOne('poll').call(this);
  }
  option() {
    const result = Model.hasOne('option').call(this);
    return result === false ? null : result;
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  pollId() {
    return Model.attribute('pollId').call(this);
  }
  optionId() {
    return Model.attribute('optionId').call(this);
  }
  rank() {
    return Model.attribute('rank').call(this);
  }
}
flarum.reg.add('fof-polls', 'forum/models/PollVote', PollVote);